import { SidebarSection } from 'components/SearchSideBar/SidebarSection';
import { SearchEmploymentStatus } from 'components/SearchSideBar/SearchEmploymentStatus';
import { SearchIncome } from 'components/SearchSideBar/SearchIncome';
import { FC, memo } from 'react';
import { UpdateJobCountType } from 'components/SearchSideBar/types';
import {
  EmploymentStatusType,
  IncomeType,
  IndustryType,
  LocationType,
  OccupationType,
  RouteStationType,
} from './types';
import { convertToIncomeValueFromQuery } from '../logics/createQuery/incomeQuery';
import { ModalConditions } from './ModalConditions';

/**
 * BasicInfoコンポーネントのProps
 */
export interface Props {
  /** 各種条件 */
  conditions: {
    occupation: OccupationType;
    location: LocationType;
    routeStation: RouteStationType;
    industry: IndustryType;
    employmentStatus: EmploymentStatusType;
    income: IncomeType;
  };
  /** モーダルを開くためのアクション */
  modalAction: {
    onOpenOccupationModal: () => void;
    onOpenLocationModal: () => void;
    onOpenRouteModal: () => void;
    onOpenIndustryModal: () => void;
  };
  /** モーダル表示時の求人数取得関数 */
  getJobCountAtModalDisplay: {
    getJobCountWithoutOccupation: () => Promise<void>;
    getJobCountWithoutLocationAndStation: () => Promise<void>;
    getJobCountWithoutIndustry: () => Promise<void>;
  };
  /** 求人数を更新する関数 */
  updateJobCount: UpdateJobCountType;
  /** オーバーレイの表示状態を変更する関数 */
  onChangeIsShowOverlay: () => void;
}

/**
 * BasicInfoコンポーネント
 * 基本条件の設定を行うためのサイドバーボックス
 *
 * @param {Props} props コンポーネントのプロパティ
 * @returns {JSX.Element}
 */
export const BasicInfo: FC<Props> = memo(
  ({
    conditions,
    modalAction,
    getJobCountAtModalDisplay,
    updateJobCount,
    onChangeIsShowOverlay,
  }) => {
    const { employmentStatus, income } = conditions;

    return (
      <SidebarSection title="基本条件">
        <>
          <ModalConditions
            conditions={conditions}
            modalAction={modalAction}
            getJobCountAtModalDisplay={getJobCountAtModalDisplay}
            updateJobCount={updateJobCount}
            onChangeIsShowOverlay={onChangeIsShowOverlay}
          />
          <SearchEmploymentStatus
            list={employmentStatus.employmentStatusList}
            updateIsChecked={employmentStatus.updateIsCheckEmploymentStatusList}
            updateJobCount={updateJobCount}
            onChangeIsShowOverlay={onChangeIsShowOverlay}
          />
          <SearchIncome
            defaultValue={{
              lower: income.lowerIncome,
              upper: income.upperIncome,
            }}
            onChangeLowerIncome={(value) => {
              income.updateLowerIncome(value);
              updateJobCount({
                lowerLimitIncome: convertToIncomeValueFromQuery(value),
              });
            }}
            onChangeUpperIncome={(value) => {
              income.updateUpperIncome(value);
              updateJobCount({
                upperLimitIncome: convertToIncomeValueFromQuery(value),
              });
            }}
            isIncomeRangeError={income.isIncomeRangeError}
            onChangeIsShowOverlay={onChangeIsShowOverlay}
          />
        </>
      </SidebarSection>
    );
  }
);

BasicInfo.displayName = 'BasicInfo';
